export interface AssistantCron {
  id: number;
  user_id: number;
  assistant_id: number;
  assistant_name?: string;
  name: string;
  prompt: string;
  interval_minutes: number;
  enabled: boolean;
  last_run_at: string | null;
  next_run_at: string | null;
  last_status: string | null;
  last_message: string | null;
  filter_min_tickets_pending: number | null;
  created_at: string;
  updated_at: string;
}

export interface AssistantCronFilters {
  assistant_id?: number;
  enabled?: boolean;
  name?: string;
  last_status?: string;
}

export interface AssistantCronResponse {
  data: AssistantCron[];
  pagination: {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
  };
}

export const ALLOWED_INTERVALS = [1, 5, 10, 15, 30, 60, 120, 360, 720, 1440] as const;

export const INTERVAL_LABELS: Record<number, string> = {
  1: '1 minuto',
  5: '5 minutos',
  10: '10 minutos',
  15: '15 minutos',
  30: '30 minutos',
  60: '1 hora',
  120: '2 horas',
  360: '6 horas',
  720: '12 horas',
  1440: '24 horas',
};
